import { Link } from 'react-router-dom';
import { AcceptedPaymentStrip } from './payment/AcceptedPaymentBrands';
import { Logo } from './Logo';
import { useAuth } from '../lib/AuthContext';
import { useCookieConsent } from '../lib/CookieConsentContext';

const labelClass =
  'mb-1 w-full text-[10px] font-semibold uppercase tracking-wide text-text-muted sm:mb-0 sm:w-auto sm:shrink-0';

export function Footer() {
  const { isAccountManager, isSuperAdmin, user } = useAuth();
  const { reopenBanner } = useCookieConsent();
  const authed = !!user?.authenticated;

  const link = 'text-xs text-text-muted transition-colors hover:text-primary hover:underline';

  return (
    <footer className="mt-auto border-t border-border/90 bg-surface-card/95 py-5 sm:py-6">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <div className="flex flex-col gap-5 sm:flex-row sm:items-start sm:justify-between sm:gap-8">
          <div className="flex min-w-0 items-center gap-3">
            <Logo variant="footer" size={28} />
            <p className="max-w-[220px] text-xs leading-snug text-text-muted sm:max-w-xs">
              Modelbegrotingen, instelbare calculatie-export en offerte-ondersteuning voor renovatie, splitsing en
              transformatie.
            </p>
          </div>
          <div className="flex min-w-0 flex-1 flex-col gap-4 sm:max-w-2xl sm:items-end">
            <nav className="flex w-full flex-col gap-1 sm:items-end" aria-label="Navigatie">
              <p className={labelClass}>Website</p>
              <div className="flex flex-wrap gap-x-4 gap-y-1.5 sm:justify-end">
                <Link to="/" className={link}>
                  Home
                </Link>
                <Link to="/prijzen" className={link}>
                  Pakketten
                </Link>
                <Link to="/betaalmethoden" className={link}>
                  Betaalmethoden
                </Link>
                <Link to="/demo" className={link}>
                  Product-demo
                </Link>
                <Link to="/blog" className={link}>
                  Blog
                </Link>
                <Link to="/reviews" className={link}>
                  Reviews
                </Link>
                {authed && (
                  <>
                    <Link to="/dashboard" className={link}>
                      Dashboard
                    </Link>
                    <Link to="/account" className={link}>
                      Account
                    </Link>
                    {isAccountManager ? (
                      <Link to="/account/billing" className={link}>
                        Abonnement
                      </Link>
                    ) : null}
                    <Link to="/projects/new" className={link}>
                      Nieuw dossier
                    </Link>
                  </>
                )}
                <Link to="/contact" className={link}>
                  Contact
                </Link>
                <Link to="/status" className={link}>
                  Dienststatus
                </Link>
                <Link to="/troubleshoot" className={link}>
                  Problemen oplossen
                </Link>
              </div>
            </nav>

            <nav className="flex w-full flex-col gap-1 sm:items-end" aria-label="Handleidingen">
              <p className={labelClass}>Handleidingen</p>
              <div className="flex flex-wrap gap-x-4 gap-y-1.5 sm:justify-end">
                <Link to="/help/tekening" className={link}>
                  Tekening &amp; PDF
                </Link>
                <Link to="/help/export" className={link}>
                  Export &amp; offerte
                </Link>
                <Link to="/help/bibliotheek" className={link}>
                  Prijsbibliotheek
                </Link>
              </div>
            </nav>

            <nav className="flex w-full flex-col gap-1 sm:items-end" aria-label="Juridisch">
              <p className={labelClass}>Juridisch</p>
              <div className="flex flex-wrap gap-x-4 gap-y-1.5 sm:justify-end">
                <Link to="/privacy" className={link}>
                  Privacy
                </Link>
                <Link to="/terms" className={link}>
                  Voorwaarden
                </Link>
                <Link to="/cookies" className={link}>
                  Cookies
                </Link>
                <button type="button" onClick={reopenBanner} className={`${link} text-left`}>
                  Cookies wijzigen
                </button>
                {isSuperAdmin && (
                  <Link to="/admin" className={link}>
                    Platformbeheer
                  </Link>
                )}
              </div>
            </nav>
          </div>
        </div>

        <div className="mt-5 border-t border-border/60 pt-4">
          <p className="mb-2 text-center text-[10px] font-semibold uppercase tracking-wide text-text-muted">
            Veilig betalen met o.a.
          </p>
          <div className="-mx-1 overflow-x-auto px-1 pb-0.5 sm:mx-0 sm:overflow-visible sm:pb-0">
            <AcceptedPaymentStrip centered className="min-w-max sm:min-w-0" />
          </div>
        </div>

        <p className="mt-4 border-t border-border/60 pt-3 text-center text-[11px] text-text-muted">
          © {new Date().getFullYear()} CalqTool™
        </p>
      </div>
    </footer>
  );
}
